export default __webpack_public_path__ + "static/media/analisis_de_datos_alimentacion.a5ce7b47.png";